import createAction from '../actionCreator';

const action = createAction('session');

export const ME = action('ME');
export const UPDATE_USER = action('UPDATE_USER');
export const STORES = action('STORES');
export const SELECT_STORE = action('SELECT_STORE');
export const DISCONNECT_STORE = action('DISCONNECT_STORE');
export const LOGOUT = action('LOGOUT');
export const UPDATE_PREFERENCES = action('UPDATE_PREFERENCES');
